import React from 'react';
import { IconTooltip } from '@grnhse/seedling/lib/birch/components/tooltips';
import ShieldExclamationIcon from '@grnhse/seedling/lib/birch/icons/shield_exclamation';
import { FullPalette } from '@grnhse/seedling/lib/birch/colors';
import { SizeOption } from '@grnhse/seedling/lib/birch/icons/base';
import { withLocalePrefix } from '../shared/utils/translation';

const t = withLocalePrefix('fraud');

type FraudIconProps = {
  size?: SizeOption;
};

export const FraudIcon = ({ size }: FraudIconProps) => {
  const Icon = () => (
    <ShieldExclamationIcon
      color={FullPalette.POPPY_600}
      size={size}
      data-provides="fraud-icon"
    />
  );
  const label = t('fraud_icon.tooltip');

  return <IconTooltip label={label} ariaLabel={label} icon={Icon} />;
};
